import { render } from "./ConfigTicketsDialog.vue?vue&type=template&id=4712453e"
import script from "./ConfigTicketsDialog.vue?vue&type=script&lang=js"
export * from "./ConfigTicketsDialog.vue?vue&type=script&lang=js"

import "./ConfigTicketsDialog.vue?vue&type=style&index=0&id=4712453e&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__